const storeName = 'SEARCH';
export default {
    SET_CATEGORIES: `${storeName}.SET_CATEGORIES`,
    SET_CONTENT_SUGGESTIONS: `${storeName}.SET_CONTENT_SUGGESTIONS`,
    SET_PRODUCTS: `${storeName}.SET_PRODUCTS`,
    SET_STORES: `${storeName}.SET_STORES`,
    SET_BASE_URL_SUFFIX: `${storeName}.SET_BASE_URL_SUFFIX`,
    ADD_RECENT_SEARCH: `${storeName}.ADD_RECENT_SEARCH`,
    SET_RECENT_SEARCH: `${storeName}.SET_RECENT_SEARCH`,
    GET_RECENT_SEARCH: `${storeName}.GET_RECENT_SEARCH`,
    CLEAR_RECENT_SEARCHES: `${storeName}.CLEAR_RECENT_SEARCHES`,
    SET_VALUE: `${storeName}.SET_VALUE`,
    SET_INPUT_VALUE: `${storeName}.SET_INPUT_VALUE`,
    SET_STATIC_SUGGESTION: `${storeName}.SET_STATIC_SUGGESTION`,
    SET_API_RESPONSE_SUCCEDED: `${storeName}.SET_API_RESPONSE_SUCCEDED`,
    DO_SEARCH: `${storeName}.DO_SEARCH`,
    CHANGE_FILTER: `${storeName}.CHANGE_FILTER`,
    CHANGE_SORTING: `${storeName}.CHANGE_SORTING`,
    CLEAR_FILTERS: `${storeName}.CLEAR_FILTERS`,
    CLEAR_GROUP_OF_FILTERS: `${storeName}.CLEAR_GROUP_OF_FILTERS`,
    APPLY_FILTERS: `${storeName}.APPLY_FILTERS`,
    SET_NEW_DOC: `${storeName}.SET_NEW_DOC`,
    SET_FILTERS_ARE_APPLIED: `${storeName}.SET_FILTERS_ARE_APPLIED`,
    SET_FILTERS_VALIDATED: `${storeName}.SET_FILTERS_VALIDATED`,
    FILTER_LOADING: `${storeName}.FILTER_LOADING`,
    DO_FILTER_BY_VALUE: `${storeName}.DO_FILTER_BY_VALUE`,
    SET_AUTO_SUGGESTIONS: `${storeName}.SET_AUTO_SUGGESTIONS`,
    GET_SECONDARY_RESULTS_TOTAL: `${storeName}.GET_SECONDARY_RESULTS_TOTAL`,
    SET_SECONDARY_RESULTS_TOTAL: `${storeName}.SET_SECONDARY_RESULTS_TOTAL`,
    SET_BRAND_SUGGESTIONS: `${storeName}.SET_BRAND_SUGGESTIONS`,
    GET_POPULAR_SUGGESTIONS: `${storeName}.GET_POPULAR_SUGGESTIONS`,
    SET_POPULAR_SUGGESTIONS: `${storeName}.SET_POPULAR_SUGGESTIONS`,
    SET_SUGGESTIONS_RECEIVED: `${storeName}.SET_SUGGESTIONS_RECEIVED`,
    SET_FILTER_GROUP_EXPANDED: `${storeName}.SET_FILTER_GROUP_EXPANDED`,
    SET_SUGGESTIONS_OPENED: `${storeName}.SET_SUGGESTIONS_OPENED`,
    SET_LAST_SEARCH: `${storeName}.SET_LAST_SEARCH`,
    SET_SEARCH_FROM_CATEGORIES: `${storeName}.SET_SEARCH_FROM_CATEGORIES`,
    CLEAR_LAST_CHANGED_FILTERS_GROUP: `${storeName}.CLEAR_LAST_CHANGED_FILTERS_GROUP`,
    CLEAR_FILTERS_BEFORE_RENDER: `${storeName}.CLEAR_FILTERS_BEFORE_RENDER`,
    SET_FILTER_ACCORDION_OPENED: `${storeName}.SET_FILTER_ACCORDION_OPENED`,
    ADD_SELECTED_FACET_GROUP: `${storeName}.ADD_SELECTED_FACET_GROUP`,
    REMOVE_SELECTED_FACET_GROUPS: `${storeName}.REMOVE_SELECTED_FACET_GROUPS`,
    UPDATE_PAGE_BY_URL: `${storeName}.UPDATE_PAGE_BY_URL`,
    SET_FILTER_PRICE_RANGE: `${storeName}.SET_FILTER_PRICE_RANGE`,
    SET_NO_RESULTS_MESSAGE: `${storeName}.SET_NO_RESULTS_MESSAGE`,
    SET_HAS_RESULTS: `${storeName}.SET_HAS_RESULTS`,
    SEARCH_PRODUCT: `${storeName}.SEARCH_PRODUCT`,
    SET_SEARCH_FOR_EXT_SERVICE: `${storeName}.SET_SEARCH_FOR_EXT_SERVICE`,
    SEARCH_RESULTS_PAGE_INFO: `${storeName}.SEARCH_RESULTS_PAGE_INFO`,
    SET_EXTERNAL_CATALOGS_MAPPING: `${storeName}.SET_EXTERNAL_CATALOGS_MAPPING`,
    SET_REMOVE_SEO_TEXT: `${storeName}.SET_REMOVE_SEO_TEXT`,
    SET_HAS_EXTERNAL_CATALOGS_MAPPING: `${storeName}.SET_HAS_EXTERNAL_CATALOGS_MAPPING`,
};
